import { Component } from '@angular/core';

@Component({
  selector: 'cert-empty-landing',
  templateUrl: './empty-landing.component.html',
  styles: ``,
  standalone: false,
})
export class EmptyLandingComponent {}
